export default __webpack_public_path__ + "static/media/fauna-qs-top-th.af37a29b.png";